export default "__VITE_ASSET__D3xyvQIb__"